export default {
    title: "Nem kézbesített tételek",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Köszönöm",
        message: "Köszönöm a válaszát."
    },
    message: "Jelezted, hogy nem kaptad meg a csomagodat, annak ellenére, hogy a futár kézbesítettként jelölte meg.",
    cta: "Kérjük, kövesse az alábbi lépéseket a probléma elhárításához:",
    items: {
        1: {
            message: "Kattintson a követési link(ek)re:"
        },
        2: {
            message: "Tekintse át a kézbesítés állapotát. Ellenőrizze a következőket:",
            items: {
                1: "Ki írta alá a csomagot",
                2: "Ha visszaküldték a feladónak",
                3: "Ha a csomag átvételre vár"
            }
        },
        3: {
            message: "Ellenőrizze a kézbesítési értesítést, amely jelzi, hogy hol hagyhatta a küldeményt."
        },
        4: {
            message: "Érdeklődjön a szomszédoknál, rokonoknál és barátoknál, akik esetleg elvették a csomagot."
        }
    },
    question: "Segített ez a kézbesítéssel kapcsolatos kérdésében? Megvan már a termék, vagy tudja, hogy kinél van? Kérjük, válaszoljon alább.",
    product: {
        name: "Elem neve",
        quantity: "Mennyiség",
        tracking: "Követés",
    },
    buttons: {
        yes: "Igen",
        no: "Nem",
        saving: "Megtakarítás"
    }
}